import {
    AbstractPmsApiService
} from "./abstract.service";
import {
    Account
} from "../models";

/**
 * @class AccountPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<City>}
 */
export class AccountPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/account(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @param {...*} params
     * @returns {Account}
     * @protected
     */
    newModel(attributes, ...params) {

        return new Account(attributes);
    }

    /**
     * @param {Object} params
     * @returns {Promise.<PaginationCollection<Country>>}
     */
    get(params = {}) {

        const url = this.url();
        const ignoreLB = params.hasOwnProperty('searchValue');
        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
                ignoreLoadingBar: ignoreLB
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Account} account
     * @returns {Promise.<Account>}
     */
    create(account) {

        const url = this.url();

        return this.http
            .post(url, account, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Account} account
     * @returns {Promise.<Country>}
     */
    update(account) {

        const url = this.url({
            id: account.id
        });

        return this.http
            .put(url, account, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Account} account
     * @returns {Promise.<boolean>}
     */
    delete(account) {

        const url = this.url({
            id: account.id
        });

        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    resend(account) {

        const url = `${this.url({id: account.id})}/resend-email`;

        return this.http
            .post(url, {}, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    show(account) {

        const url = this.url({
            id: account.id
        });

        return this.http.get(url, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/account.service.js